import { shouldDesynchronizeCanvas } from '@/app/utils/canvas';

export const THREESIXTY_CANVAS_WIDTH = 960;
export const THREESIXTY_CANVAS_HEIGHT = 768;
export const THREESIXTY_MOBILE_CANVAS_MAX_DPR = 3;
export const THREESIXTY_DESKTOP_CANVAS_MAX_DPR = 2;

interface CanvasSourceSize {
  width: number;
  height: number;
}

export const shouldDesynchronizeThreesixtyCanvas = shouldDesynchronizeCanvas;

export const getCanvasPixelSize = (
  canvas: HTMLCanvasElement,
  sourceSize?: CanvasSourceSize
) => {
  const cssWidth = canvas.clientWidth || THREESIXTY_CANVAS_WIDTH;
  const maxDpr =
    window.innerWidth < 1024
      ? THREESIXTY_MOBILE_CANVAS_MAX_DPR
      : THREESIXTY_DESKTOP_CANVAS_MAX_DPR;
  const dpr = Math.min(window.devicePixelRatio || 1, maxDpr);
  const sourceWidth = sourceSize?.width || THREESIXTY_CANVAS_WIDTH;
  const sourceHeight = sourceSize?.height || THREESIXTY_CANVAS_HEIGHT;
  const width = Math.max(1, Math.round(Math.min(cssWidth * dpr, sourceWidth)));
  const scale = width / sourceWidth;

  return {
    width,
    height: Math.max(1, Math.round(sourceHeight * scale)),
  };
};

export const copyThreesixtyCanvas = (
  source: HTMLCanvasElement,
  destination: HTMLCanvasElement | null
) => {
  if (!destination || source.width <= 0 || source.height <= 0) return;

  if (
    destination.width !== source.width ||
    destination.height !== source.height
  ) {
    destination.width = source.width;
    destination.height = source.height;
  }

  const context = destination.getContext('2d');
  if (!context) return;

  context.clearRect(0, 0, destination.width, destination.height);
  context.drawImage(source, 0, 0);
};
